document.addEventListener('DOMContentLoaded', function () {
    let fileInput = document.querySelectorAll('.form-control--file');

    if (fileInput) {
        fileInput.forEach(function (el) {
            el.addEventListener('change', function () {
                if (el.files.length > 0) {
                    el.classList.add('file-selected');
                } else {
                    el.classList.remove('file-selected');
                }
            });
        });
    }
});
